import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { createContext } from "use-context-selector";

import enMessages from "../translations/en.json";
import zhMessages from "../translations/zh.json";
import { IntlProvider } from "react-intl";
import flat from "flat";
import { Box } from "@mui/material";
import { Languages } from "types";

interface Language {
  readonly appLocale: string;
  readonly appMessages: {};
  readonly setAppLocale: Dispatch<SetStateAction<Languages>>;
}

interface LanguageContextProviderProps {
  readonly children: JSX.Element[] | JSX.Element;
}

export const LanguageContext = React.createContext<Language>({
  appLocale: "",
  appMessages: {},
  setAppLocale: () => {},
});

export const LanguageContextProvider: React.FC<
  LanguageContextProviderProps
> = ({ children }) => {
  const [appLocale, setAppLocale] = useState(
    navigator.language.includes(Languages.CHINESE)
      ? Languages.CHINESE
      : Languages.ENGLISH
  );
  const [appMessages, setAppMessages] = useState(
    navigator.language.includes(Languages.CHINESE) ? zhMessages : enMessages
  );

  useEffect(() => {
    if (appLocale === Languages.CHINESE) {
      setAppMessages(zhMessages);
    } else {
      setAppMessages(enMessages);
    }
  }, [appLocale]);

  return (
    <LanguageContext.Provider value={{ appLocale, setAppLocale, appMessages }}>
      <IntlProvider locale={appLocale} messages={flat(appMessages)}>
        <Box
          sx={{
            background: "#F8F8F8",
          }}
        >
          {children}
        </Box>
      </IntlProvider>
    </LanguageContext.Provider>
  );
};
